export default __webpack_public_path__ + "static/media/hvac.f63ca062.webp";